import { api } from "../api";

/**
 * findLastFuelingByVehicleResponse - Function that finds the last fueling of each vehicle (fueling module first, fuel expenses as fallback).
 * Only vehicles that have some fueling data are returned.
 * /vehicles/fuelings/last/{customerId}
 * method POST
 * @async-function
 */
const findLastFuelingByVehicleResponse = async (token: string, customerId: number, vehicleIds: Array<number>) => {
    const response = await api.post(
        `/vehicles/fuelings/last/${customerId}`,
        { vehicleIds },
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    )
    return response;
};
export default findLastFuelingByVehicleResponse;
